import { NumberMaybe } from "../../common/CCUtils"
import {
    fbFunctions,
    FbUtils,
    portalUserCollection,
} from "../../common/FirebaseConfig"
import { log } from "../../common/Logging"
import { MonthMaybe } from "../../common/TimeUtils"
import { ClassGrade } from "../../shared/models/Clazz"
import { Gender } from "../../shared/models/Gender"

export interface StudentAccount {
    firstName: string
    lastName: string
    studentId: string
    birthDay: NumberMaybe
    birthMonth: MonthMaybe
}

export enum BuddyName {
    BOY = "Lucas",
    GIRL = "Isabella",
}

export interface Teacher {
    firstName: string
    lastName: string
    preferredTitle: string
}

export class StudentAccountStore {
    private static innerInstance: StudentAccountStore

    classCode = ""
    classId = ""
    classGrade: ClassGrade | undefined
    teacherName = ""

    studentAccount: StudentAccount = {
        firstName: "",
        lastName: "",
        studentId: "",
        birthDay: "",
        birthMonth: "",
    }
    birthCode: string

    gender: Gender

    screenname = ""

    static get instance() {
        return this.innerInstance || (this.innerInstance = new this())
    }

    findTeacherByTeacherId = async (teacherId: string) => {
        const teacher = await portalUserCollection().doc(teacherId).get()
        log.debug(teacher)
        return FbUtils.queryDocToDoc(teacher) as Teacher
    }

    isScreenNameUnique = async (screenname: string) => {
        log.debug("Begin check if screenname is unique.")
        const result = await fbFunctions().httpsCallable(
            "screennameUniqueForClass",
        )({ classId: this.classId, screenname })
        log.debug("End check if screenname is unique.")
        return result
    }

    clearStore = () => {
        log.debug("student account creation store cleared")
        StudentAccountStore.innerInstance = null
    }
}
